import Offer from "../OfferClass/Offer/Offer";
import LoyaltyOffer from "../LoyaltyOfferClass/LoyaltyOffer";
import { MAIN_OFFER_TYPE } from "../enums";

export function asLegacyOffer(
  offer: Offer | LoyaltyOffer | undefined
): Offer | undefined {
  return offer instanceof Offer ? offer : undefined;
}

export function isLegacyBogoOrBundleRedeemed(
  offer: Offer | LoyaltyOffer | undefined
): boolean {
  const legacy = asLegacyOffer(offer);

  return (
    !!legacy &&
    (legacy.offerType === MAIN_OFFER_TYPE.BOGO ||
      legacy.offerType === MAIN_OFFER_TYPE.BUNDLE)
  );
}

export function legacyOfferId(
  offer: Offer | LoyaltyOffer | undefined
): number | undefined {
  return asLegacyOffer(offer)?.id;
}
